import React from 'react';
import { APP_BASENAME } from '../App';
import ModeToggle from './ModeToggle';
import { useFormContext } from '../contexts/FormContext';
import { Link } from 'react-router-dom';
import LanguageSelector from './common/LanguageSelector';
import { useTranslation } from 'react-i18next';

const Header = () => {
  const { isProMode, toggleProMode } = useFormContext();
  const { t } = useTranslation();

  return (
    <header className="max-w-5xl mx-auto mb-8 pt-4">
      <div className="flex justify-between items-center">
        <a href={APP_BASENAME} className="flex items-center py-2">
          <img
            src={APP_BASENAME + "/predicthire.png"}
            alt="PredictHire"
            className="h-8 w-auto object-contain"
          />
        </a>
        <div className="flex items-center gap-4">
          <Link 
            to="/pricing"
            className="py-3 text-base font-medium px-7 text-gray-800 hover:text-blue-600 transition-colors"
          >
            {t('header.pricing')}
          </Link>
          <ModeToggle
            isProMode={isProMode}
            setIsProMode={toggleProMode}
          />
          <LanguageSelector />
          <div className="flex items-center">
            <a
              href="https://app.predicthire.com/signin"
              className="py-3 text-base font-medium px-7 text-gray-800 hover:text-blue-600 transition-colors"
            >
              {t('header.login')}
            </a>
            <a
              href="https://app.predicthire.com/register"
              className="py-3 text-base font-medium text-white rounded-md bg-blue-600 px-7 hover:bg-blue-700 transition-colors"
            >
              {t('header.signUp')}
            </a>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header; 